import { createClient } from "@supabase/supabase-js";

import { Database } from "./supabase";
import { getStoredAccount } from "@SonarCX/providers/AccountProvider";

const SUPABASE_URL = "https://rjvjyfvropcqtvhohbrx.supabase.co";
const SUPABASE_PUBLISHABLE_KEY =
  "sb_publishable_VJDKObfGvbv4UNcHMHaLlw_OrBHhSfR";
const client = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);

export const getTaskCategoryRules = async () => {
  const accountId = getStoredAccount();
  if (!accountId) {
    console.error("No account ID found in stored account.");
    return [];
  }
  const { data, error } = await client
    .from("task-category-rules")
    .select("*")
    .eq("account_id", accountId);

  if (error) {
    console.error(`Error fetching task category rules: ${error.message}`);
    return [];
  }

  return data;
};

export const upsertTaskCategoryRule = async ({
  id,
  categoryId,
  types,
}: {
  id?: number;
  categoryId: string;
  types: string[];
}) => {
  const accountId = getStoredAccount();
  if (!accountId) {
    console.error("No account ID found in stored account.");
    return null;
  }
  const { data, error } = await client
    .from("task-category-rules")
    .upsert({
      id,
      account_id: accountId,
      task_category_id: categoryId,
      task_type_ids: types,
    })
    .eq("account_id", accountId)
    .eq("task_category_id", categoryId)
    .select();

  if (error) {
    console.error(`Error adding task category rule: ${error.message}`);
    return null;
  }

  return data ? data[0] : null;
};

export const deleteTaskCategoryRule = async (id: number) => {
  const accountId = getStoredAccount();
  if (!accountId) {
    console.error("No account ID found in stored account.");
    return false;
  }
  const { error } = await client
    .from("task-category-rules")
    .delete()
    .eq("id", id)
    .eq("account_id", accountId);

  if (error) {
    console.error(`Error deleting task category rule: ${error.message}`);
    return false;
  }

  return true;
};

export default client;
